<template>
  <!--个人中心顶部-->
  <div class="member_top box">
    <div class="w1200 wrap">
      <div class="col_1 w320 m_left">
        <dl>
          <dt>
            <img src="./images/member_header.png" v-if="!userInfo || !userInfo.head || userInfo.head==='' || userInfo.head==='undefined'"/>
            <img :src="userInfo.head" v-if="userInfo && userInfo.head && userInfo.head!=='' && userInfo.head!=='undefined'"/>
          </dt>
          <dd>
            <h3 v-if="!userInfo || !userInfo.nickname">游客</h3>
            <h3 v-if="userInfo && userInfo.nickname">{{ userInfo.nickname }}</h3>
            <p v-if="userInfo && userInfo.company">{{ userInfo.company }}</p>
          </dd>
        </dl>
      </div>
      <div class="col_2 w580 m_right">
        <!--已获得证书-->
        <div class="kuang_a">
          <dl>
            <dt v-if="statistics && statistics.cnt2">{{ statistics.cnt2 }}</dt>
            <dt v-if="!statistics || !statistics.cnt2">0</dt>
            <dd>已获得证书</dd>
          </dl>
        </div>
        <!--/已获得证书-->
        <!--已获得学时学分-->
        <div class="kuang_b">
          <dl>
            <dt v-if="statistics && statistics.cnt1">{{ statistics.cnt1 }}</dt>
            <dt v-if="!statistics || !statistics.cnt1">0</dt>
            <dd>已完成考试次数</dd>
          </dl>
        </div>
        <!--/已获得学时学分-->
        <!--已课程完成数量-->
        <div class="kuang_c">
          <dl>
            <dt v-if="statistics && statistics.cnt0">{{ statistics.cnt0 }}</dt>
            <dt v-if="!statistics || !statistics.cnt0">0</dt>
            <dd>已完成课程数量</dd>
          </dl>
        </div>
        <!--/已课程完成数量-->
      </div>
      <div class="clear"></div>
    </div>
  </div>
  <!--/个人中心顶部-->
</template>
<script>
export default {
  name: 'MemberTop',
  props: ['userInfo', 'statistics']
}
</script>
<style scoped>
  .member_top {
    background: url(./images/study_top_by.jpg) center top no-repeat #606060;
    height: 128px;
    margin-top: 0px;
  }

  .member_top .m_left dl {
    height: 75px;
    margin-top: 25px;
  }

  .member_top .m_left dt {
    width: 75px;
    float: left;
  }

  .member_top .m_left dt img {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    border: 1px solid #f0f0f0;
  }

  .member_top .m_left dd {
    color: #fff;
    margin-left: 10px;
    float: left;
    padding-top: 15px;
  }

  .member_top .m_left dd h3 {
    font-size: 18px;
    font-weight: normal;
  }

  .member_top .m_left dd p {
    color: #fff;
    padding-top: 5px;
  }

  .member_top .m_right {
    height: 128px;
    position: relative;
  }

  .member_top .m_right .kuang_a {
    width: 181px;
    height: 84px;
    background: url(./images/member_top_k_1@2x.png);
    position: absolute;
    bottom: 0;
    right: 0px;
  }

  .member_top .m_right .kuang_b {
    width: 181px;
    height: 84px;
    background: url(./images/member_top_k_2@2x.png);
    position: absolute;
    bottom: 0;
    right: 189px;
  }

  .member_top .m_right .kuang_c {
    width: 181px;
    height: 84px;
    background: url(./images/member_top_k_3@2x.png);
    position: absolute;
    bottom: 0;
    right: 378px;
  }

  .member_top .m_right dl {
    text-align: center;
    color: #fff;
  }

  .member_top .m_right dl dt {
    font-size: 28px;
    color: #fff;
    height: 50px;
    line-height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/byl/memTop/top.vue